module.exports = "/images/whiteArrow.svg";